import type { Group } from '../../../utils/context/DealHookTypes.ts';

export type SortDealGroupReturnType = (Group[number] & { isOutside: boolean })[];

export const sortDealGroup = (group: Group, currentUid?: string): SortDealGroupReturnType => {
  if (group.length === 0) return [];

  const idx = group.findIndex(({ uid }) => uid === currentUid);
  if (idx !== -1) {
    const [item] = group.splice(idx, 1);
    group.unshift(item);
  }

  return group.map(item => ({
    ...item,
    isOutside: item.uid !== currentUid,
  }));
};
